import { ArrowLeft2 } from 'iconsax-react';
import { TInvestmentBannerProps } from '../model';
import Link from 'next/link';

export function InvestmentSecondaryBanner(props: TInvestmentBannerProps) {
  return (
    <Link
      href={props.href}
      target='_blank'
      className='flex flex-col justify-self-center mt-4 w-[1000px] min-w-[900px] relative h-[130px] overflow-hidden rounded-xl text-white'
    >
      <div
        className='absolute inset-0 bg-cover bg-center'
        style={{ backgroundImage: `url(${props.backgroundImage})` }}
      />

      <div className='relative flex w-full flex-row justify-between px-4 py-4 '>
        <div className='flex flex-row gap-3'>
          <div className='h-[42px] w-[42px] rounded-[12px] bg-white p-[8px]'>
            {props.icon}
          </div>
          <div className='flex flex-col gap-4'>
            <div className='flex-col items-start justify-between'>
              <div className='flex flex-col gap-2'>
                <p className='text-sm font-bold'>{props.title}</p>
              </div>
            </div>

            <p className='text-xs opacity-90'>{props.description}</p>

            <div className='flex items-center gap-[10px]'>
              {props.tags &&
                props.tags.map((tag, index) => (
                  <span
                    key={`${tag.title}-${index}`}
                    className='flex items-center gap-1 rounded-[6px] bg-white px-2 py-1 body-12-regular  text-[#323E54]'
                  >
                    {tag.title}
                  </span>
                ))}
            </div>
          </div>
        </div>

        <span className='rounded-[8px] bg-white p-[6px] h-[32px] w-[32px] justify-self-center self-center'>
          <ArrowLeft2 size={20} className=' text-[#323E54]' />
        </span>
      </div>
    </Link>
  );
}
